<div class="asset-filter">
  <div class="asset-filter__heading" *ngIf="selectedItem">
    <div class="asset-filter__heading__title">
      {{ selectedItem.name }}
    </div>
    <div class="asset-filter__heading__back" (click)="changeSelection(null, $event)">
      <kui-icon kui-action name="chevron-left"></kui-icon> {{ 'SHARED.BACK' | translate }}
    </div>
  </div>
  <div class="asset-filter__items" *ngIf="!selectedItem">
    <div class="asset-filter__items__item" *ngFor="let item of getNonEmptyFilters(filters)" kui-action (click)="changeSelection(item, $event)">
      <div class="asset-filter__items__item__title">
        {{ item.name }}
      </div>
      <div class="asset-filter__items__item__action">
        <span *ngIf="!getSelection(item)">
          {{ 'SHARED.ANY' | translate }}
        </span>
        <span *ngIf="getSelection(item)">
          {{ getSelection(item) }}
        </span>
      </div>
    </div>
  </div>
  <div class="asset-filter__tree" *ngIf="selectedItem">
    <kui-tree-select
      [(state)]="treeStates[selectedItem.id]"
      (selectedNodeChanged)="filtersChanged(selectedItem, $event)"
      [nodes]="selectedItem.children">
    </kui-tree-select>
  </div>
</div>
